module.exports = __webpack_public_path__ + "img/box-bkd.cd97a6bb.svg";